import type { ExternalTableSchema } from '@packages/table-builder';

export const commissionTable: ExternalTableSchema = {
  metadata: {
    title: 'Commission',
    entity: 'Commission',
    description: 'Manage commission rate schedules.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/commission/commission-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'name',
      header: 'Schedule Name',
      type: 'text',
      width: 180,
      align: 'left',
    },
    {
      field: 'baseRate',
      header: 'Base Rate ($)',
      type: 'currency',
      width: 180,
      align: 'left',
      format: { decimals: true },
    },
    {
      field: 'brokerName',
      header: 'Broker',
      type: 'text',
      width: 180,
      align: 'left',
    },
    {
      field: 'description',
      header: 'Description',
      type: 'text',
      width: 180,
      align: 'left',
    },
    {
      field: 'noOfClient',
      header: 'Number of Clients',
      type: 'text',
      width: 180,
      align: 'left',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_COMMISSION', label: 'View' },
      { id: 'EDIT_COMMISSION', label: 'Edit' },
      { id: 'DELETE_COMMISSION', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_COMMISSION',
        label: 'Add Commission',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
  },
};
